// 空字符占位符
import intl from 'react-intl-universal'

// 密码安全等级
export const passwordSecurityLevel = {
  LOW: 'LOW', // 低
  MEDIUM: 'MEDIUM', // 中
  HIGH: 'HIGH' // 高
}
// 密码过期时间
export const passwordExpirationTime = {
  NEVER: 'NEVER', // 不过期
  THREE_MONTHS: 'THREE_MONTHS', // 三个月
  SIX_MONTHS: 'SIX_MONTHS', // 六个月
  TWELVE_MONTHS: 'TWELVE_MONTHS' // 十二个月
}

// 密码安全等级配置校验规则
export const PasswordLevelVerificationRules = {
  // 低
  [passwordSecurityLevel.LOW]: [{
    id: 0,
    label: intl.get('login.spacesCannotBeIncluded'),
    validate: (value) => {
      // 只允许字母、数字及特殊符号 ?!@#$%^*();'~.,
      return /^[a-zA-Z0-9?!@#$%^*();'~.,]*$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 1,
    label: intl.get('login.theLengthIsSixToSixteenCharacters'),
    validate: (value) => {
      return /^.{6,16}$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 2,
    label: intl.get('login.passwordSecurityLevelLow'),
    validate: (value) => {
      return (value.match(/\d/) ? 1 : 0) + (value.match(/[a-z]/) ? 1 : 0) + (value.match(/[A-Z]/) ? 1 : 0) + (value.match(/[?!@#$%^*();'~.,]/) ? 1 : 0) >= 1
    },
    iconType: 'info-circle'
  }],
  // 中
  [passwordSecurityLevel.MEDIUM]: [{
    id: 0,
    label: intl.get('login.spacesCannotBeIncluded'),
    validate: (value) => {
      // 只允许字母、数字及特殊符号 ?!@#$%^*();'~.,
      return /^[a-zA-Z0-9?!@#$%^*();'~.,]*$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 1,
    label: intl.get('login.theLengthIsEightToSixteenCharacters'),
    validate: (value) => {
      return /^.{8,16}$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 2,
    label: intl.get('login.passwordSecurityLevelMedium'),
    validate: (value) => {
      return (value.match(/\d/) ? 1 : 0) + (value.match(/[a-z]/) ? 1 : 0) + (value.match(/[A-Z]/) ? 1 : 0) + (value.match(/[?!@#$%^*();'~.,]/) ? 1 : 0) >= 2
    },
    iconType: 'info-circle'
  }],
  // 高
  [passwordSecurityLevel.HIGH]: [{
    id: 0,
    label: intl.get('login.spacesCannotBeIncluded'),
    validate: (value) => {
      // 只允许字母、数字及特殊符号 ?!@#$%^*();'~.,
      return /^[a-zA-Z0-9?!@#$%^*();'~.,]*$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 1,
    label: intl.get('login.theLengthIsEightToSixteenCharacters'),
    validate: (value) => {
      return /^.{8,16}$/.test(value)
    },
    iconType: 'info-circle'
  }, {
    id: 2,
    label: intl.get('login.passwordSecurityLevelHigh'),
    validate: (value) => {
      // 特殊符号 ?!@#$%^&*();'~.,
      return (value.match(/\d/) ? 1 : 0) + (value.match(/[a-z]/) ? 1 : 0) + (value.match(/[A-Z]/) ? 1 : 0) + (value.match(/[?!@#$%^*();'~.,]/) ? 1 : 0) >= 3
    },
    iconType: 'info-circle'
  }]
}

// 强制重置密码
export const PwdValidStatus = {
  NORMAL: 'NORMAL', // 正常
  FIRST_LOGIN: 'FIRST_LOGIN', // 首次登录
  EXPIRED: 'EXPIRED', // 已过期
  HAS_BEEN_RESET: 'HAS_BEEN_RESET', // 被重置
  INSUFFICIENT_SECURITY_LEVEL: 'INSUFFICIENT_SECURITY_LEVEL', // 安全级别不足
  HAS_ILLEGAL_CHARACTER: 'HAS_ILLEGAL_CHARACTER' // 含有非法字符
}

export const PwdValidStatusDescription = {
  [PwdValidStatus.NORMAL]: '',
  [PwdValidStatus.FIRST_LOGIN]: intl.get('login.pleaseChangeYourPassword'),
  [PwdValidStatus.EXPIRED]: intl.get('login.thePasswordOfYourAccountHasExpired'),
  [PwdValidStatus.HAS_BEEN_RESET]: intl.get('login.thePasswordOfYourAccountHasBeenReset'),
  [PwdValidStatus.INSUFFICIENT_SECURITY_LEVEL]: intl.get('login.theSecurityOfYourAccountPasswordIsTooLow'),
  [PwdValidStatus.HAS_ILLEGAL_CHARACTER]: intl.get('login.thePasswordContainsIllegalCharacters')
}

// /** @type {Readonly<{ SIGN_UP: 'SIGN_UP', RESET_PASSWORD: 'RESET_PASSWORD', BACKEND_CREATE_USER: 'BACKEND_CREATE_USER', BIND_DINGDING_CLOUD: 'BIND_DINGDING_CLOUD', BIND_GERENWEIXIN: 'BIND_GERENWEIXIN', PC_SMS_LOGIN: 'PC_SMS_LOGIN', BIND_DING_TALK: 'BIND_DING_TALK' }>} */
export const Action = {
  SIGN_UP: 'SIGN_UP',
  RESET_PASSWORD: 'RESET_PASSWORD',
  BACKEND_CREATE_USER: 'BACKEND_CREATE_USER',
  BIND_DINGDING_CLOUD: 'BIND_DINGDING_CLOUD',
  BIND_GERENWEIXIN: 'BIND_GERENWEIXIN', // 个人微信绑定
  PC_SMS_LOGIN: 'PC_SMS_LOGIN', // 验证码登录
  BIND_DING_TALK: 'BIND_DING_TALK', // 钉钉绑定
  BIND_QIYEWEIXIN: 'BIND_QIYEWEIXIN', // 企业微信绑定
  BIND_FEISHU: 'BIND_FEISHU' // 飞书绑定
} as const

export const LinkGroup = {
  OFFICIAL_WEBSITE: 'http://www.yunding360.com',
  // PASSENGER_FLOW: 'https://mp.weixin.qq.com/s/zpwoaBWYn0T0OH-wJSLiUg'
  PASSENGER_FLOW: 'https://mp.weixin.qq.com/s/vnmzWDDqWnWlSXu_y1y7FA'
}

/**
 * @NEED(企业需要MFA验证且用户已经绑定MFA验证,则在登录成功后进入MFA验证流程)
 * @NEEDLESS(企业无需MFA验证,则在登录成功后直接进入主页)
 * @NO_BOUND(企业需要MFA验证且用户还未绑定任何MFA验证,则在登录成功后进入MFA绑定流程)
 * @VALIDITY_PERIOD(在验证有效期内)
 */
export const MFA_VERIFY_TYPE = {
  NEED: 'NEED',
  NEEDLESS: 'NEEDLESS',
  NO_BOUND: 'NO_BOUND',
  VALIDITY_PERIOD: 'VALIDITY_PERIOD'
}

export const MFA_TYPE = {
  TOTP: intl.get('mfa.totp'),
  MOBILE: intl.get('mfa.mobile'),
  EMAIL: intl.get('mfa.email')
}

export const INPUT_TIP = {
  MOBILE: intl.get('mfa.pleaseEnterThePhonenumber'),
  EMAIL: intl.get('mfa.pleaseEnterTheEmail'),
  CODE: intl.get('mfa.pleaseEnterTheCode'),
  TOTP: intl.get('mfa.pleaseEnterThe_6DigitSecurityCode'),
  MOBILE_EMPTY: intl.get('mfa.phoneNumberCannotBeEmpty'),
  EMAIL_EMPTY: intl.get('mfa.emailCannotBeEmpty'),
  CODE_EMPTY: intl.get('mfa.codeCannotBeEmpty'),
  TOTP_EMPTY: intl.get('mfa.securityCodeCannotBeEmpty'),
  CODE_ERROR: intl.get('mfa.pleaseEnterThe_6DigitCode'),
  FORMAT_ERROR: intl.get('mfa.pleaseEnterTheCorrectFormat')
}

export const PATTERN = {
  MOBILE: /^1[3-9]\d{9}$/,
  EMAIL: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  CODE: /^[0-9]{6}$/
}

// 字面量类型注解，避免被推断为宽泛的 string，需与 services/login/types.ts 的 ThirdPartyLoginConfig 判别字段保持一致
// /** @type {Readonly<{ WECHAT: 'wechat', WECOM: 'wecom', LARK: 'lark', DINGTALK: 'dingtalk' }>} */
export const THIRD_PARTY = {
  WECHAT: 'wechat',
  WECOM: 'wecom',
  LARK: 'lark',
  DINGTALK: 'dingtalk'
} as const

// 客户端类型
export const CLIENT_TYPE = {
  MOBILE: 'MOBILE',
  PC: 'PC',
  
} as const

// 登录来源
export const authType = {
  SCAN_CODE: 'SCAN_CODE', // 扫码登录
  SSO: 'SSO', // 单点登录
} as const